import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  makeStyles,
  Typography,
  Divider
} from '@material-ui/core';
import {
  ExpandLess,
  ExpandMore,
  Add as AddIcon,
  Person as PersonIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  Settings as SettingsIcon,
  AddAlert as AddAlertIcon,
  PlaylistAddCheck as PlaylistAddCheckIcon,
  EventNote as EventNoteIcon,
  Grain as GrainIcon,
  HomeWork as HomeWorkIcon,
  Map as MapIcon,
} from '@material-ui/icons';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

import Logo from '../assets/img/Acecura Logo.png';

const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: '#f4f4f4', // Softer background color
    overflow: 'auto',
  },
  toolbar: theme.mixins.toolbar,
  logo: {
    width: "95%",
    margin: '16px 0', // Added margin to give breathing room around logo
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  sectionTitle: {
    padding: theme.spacing(2),
    fontWeight: 'bold',
    color: '#4f4f4f',
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
}));

const Sidebar = () => {
  const classes = useStyles();
  const [openGuidance, setOpenGuidance] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(false);
  const [openModeration, setOpenModeration] = useState(false);

  const handleGuidanceClick = () => {
    setOpenGuidance(!openGuidance);
  };

  const handleQuestionClick = () => {
    setOpenQuestion(!openQuestion);
  };

  const handleModerationClick = () => {
    setOpenModeration(!openModeration);
  };

  const drawer = (
    <div>
      <img src={Logo} className={classes.logo} />

      <List>

        <ListItem button onClick={handleGuidanceClick}>
          <ListItemIcon>
            <AutoStoriesIcon />
          </ListItemIcon>
          <ListItemText primary="Guidance" />
          {openGuidance ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openGuidance} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/add-guidance" className={classes.nested}>
              <ListItemText primary="Add Guidance" />
            </ListItem>
            <ListItem button component={Link} to="/add-guidance-type" className={classes.nested}>
              <ListItemText primary="Add Guidance Type" />
            </ListItem>
            <ListItem button component={Link} to="/manage-guidance" className={classes.nested}>
              <ListItemText primary="Manage Guidance" />
            </ListItem>
            <ListItem button component={Link} to="/generate-articles" className={classes.nested}>
              <ListItemText primary="Generate Articles" />
            </ListItem>
          </List>
        </Collapse>


        <ListItem button onClick={handleQuestionClick}>
          <ListItemIcon>
            <MapIcon />
          </ListItemIcon>
          <ListItemText primary="Roadmap" />
          {openQuestion ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openQuestion} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/add-roadmap-group" className={classes.nested}>
              <ListItemText primary="Roadmap Groups" />
            </ListItem>
            <ListItem button component={Link} to="/add-question-group" className={classes.nested}>
              <ListItemText primary="Question Groups" />
            </ListItem>
            <ListItem button component={Link} to="/add-question-group-type" className={classes.nested}>
              <ListItemText primary="Question Group Types" />
            </ListItem>
            <ListItem button component={Link} to="/add-question" className={classes.nested}>
              <ListItemText primary="Add Question" />
            </ListItem>
            <ListItem button component={Link} to="/show-question-tree" className={classes.nested}>
              <ListItemText primary="Show Question Tree" />
            </ListItem>
            <ListItem button component={Link} to="/add-roadmap" className={classes.nested}>

              <ListItemText primary="Add Output" />
            </ListItem>
          </List>
        </Collapse>

        <ListItem button onClick={handleModerationClick}>
          <ListItemIcon>
            <AddModeratorIcon />
          </ListItemIcon>
          <ListItemText primary="Moderation" />
          {openModeration ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openModeration} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/moderation-community" className={classes.nested}>
              <ListItemText primary="Community Posts" />
            </ListItem>
            <ListItem button component={Link} to="/moderation-messages" className={classes.nested}>
              <ListItemText primary="Messages" />
            </ListItem>
          </List>
        </Collapse>


        <ListItem button component={Link} to="/add-notification">
          <ListItemIcon>
            <AddAlertIcon />
          </ListItemIcon>
          <ListItemText primary="Add Notification" />
        </ListItem>

        <ListItem button component={Link} to="/add-calendar-type">
          <ListItemIcon>
            <EventNoteIcon />
          </ListItemIcon>
          <ListItemText primary="Add Calendar Type" />
        </ListItem>

        <ListItem button component={Link} to="/view-user-activity">
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary="View User Activity" />
        </ListItem>

        <ListItem button component={Link} to="/manage-users">
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary="Manage Users" />
        </ListItem>

        <ListItem button component={Link} to="/care-homes">
          <ListItemIcon>
            <HomeWorkIcon />
          </ListItemIcon>
          <ListItemText primary="Care Homes" />
        </ListItem>

        <ListItem button component={Link} to="/ace-gpt">
          <ListItemIcon>
            <GrainIcon />
          </ListItemIcon>
          <ListItemText primary="Ace GPT" />
        </ListItem>

        <ListItem button component={Link} to="/system-settings">
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="System Settings" />
        </ListItem>


        <Divider className={classes.divider} />

        <ListItem button>
          <ListItemIcon>
            <PowerSettingsNewIcon />
          </ListItemIcon>
          <ListItemText primary="Signout" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      <div className={classes.root}>
        <nav className={classes.drawer} aria-label="sidebar navigation">
          <Drawer
            variant="permanent"
            className={classes.drawer}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.toolbar} />
            {drawer}
          </Drawer>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
